// RCS Support summary-tile palette: 5 cool green/teal/cyan "flow" tones, one
// neutral slate for inactive states, and one warm amber for the alert state.
// Assigned by index in the status order returned by the API.
// bg + matching ring for each tile. The ring classes are written literally so
// Tailwind's JIT keeps them (a dynamically built class name would be purged).
const CARD_COLORS = [
  { bg: "bg-tileOpen", ring: "ring-tileOpen" }, // emerald — live work
  { bg: "bg-tileActive", ring: "ring-tileActive" }, // teal
  { bg: "bg-tileReopen", ring: "ring-tileReopen" }, // deep cyan
  { bg: "bg-tileClosed", ring: "ring-tileClosed" }, // slate — inactive/recedes
  { bg: "bg-tileResolved", ring: "ring-tileResolved" }, // fresh green — positive done
  { bg: "bg-tileInfo", ring: "ring-tileInfo" }, // amber — the one alert state
];

export const Score = ({ activeIndex, setActiveIndex, count, status }) => {
  // Uniform tile matching the RCS Support reference: fixed min-height, label
  // pinned top and the big count pinned bottom (space-between), soft sheen +
  // watermark ring, and a lift-on-hover. Active tile keeps a subtle ring so
  // the click-to-filter selection stays visible without resizing the grid.
  const tileClassName =
    "relative overflow-hidden rounded-2xl p-[18px] min-h-[150px] text-white cursor-pointer flex flex-col justify-between shadow-[0_1px_2px_rgba(15,23,42,.04),0_8px_24px_rgba(15,23,42,.06)] transition-transform duration-150 hover:-translate-y-[3px]";
  const labelClassName = "relative z-[1] text-sm font-semibold text-white/90 max-w-[9ch]";
  const countClassName =
    "relative z-[1] text-[46px] font-extrabold leading-none tracking-tight";

  const renderTile = (key, label, value, colors, active) => (
    <div
      key={key}
      onClick={() => setActiveIndex(key)}
      className={`${tileClassName} ${colors.bg} ${
        active
          ? `${colors.ring} ring-4 ring-offset-2 ring-offset-gray-100 scale-[1.04] shadow-[0_12px_30px_rgba(15,23,42,.22)] z-10`
          : value === 0
          ? "opacity-[.86]"
          : "opacity-95"
      }`}
    >
      <span
        aria-hidden="true"
        className="pointer-events-none absolute -right-[30px] -bottom-[40px] w-[120px] h-[120px] rounded-full bg-white/[0.08]"
      />
      <span
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 bg-gradient-to-br from-white/[0.16] to-transparent"
      />
      <span className={labelClassName}>{label}</span>
      <span className={countClassName}>{value}</span>
    </div>
  );

  return (
    <section>
      <h1 className="text-[22px] font-extrabold tracking-tight mb-4">
        Tickets Summary
      </h1>
      <div className="grid grid-cols-2 md:grid-cols-4 xl:grid-cols-7 gap-3.5">
        {renderTile(
          "total",
          "Total",
          count.total ?? 0,
          { bg: "bg-tileTotal", ring: "ring-tileTotal" },
          activeIndex === "total",
        )}

        {(status ?? []).map((s, i) =>
          renderTile(
            s.value,
            s.key,
            count[s.value] ?? 0,
            CARD_COLORS[i % CARD_COLORS.length],
            activeIndex === s.value,
          ),
        )}
      </div>
    </section>
  );
};
